<ng-container *ngIf="ofbizList">
    <ng-container *ngIf="paginate || isMulti">
        <div class="page-filter" [nbSpinner]="!loaded">
            <ng-container *ngIf="isLookup;else noLookup">
                <div style="display:flex;flex-direction: row;justify-content: end;">
                    <ubs-pagination></ubs-pagination>
                </div>
            </ng-container>
            <ng-template #noLookup>
                <div class="filter" [class.hide_filter] = "filter === false">
                    <ng-container *ngIf="filter">
                        <div class="filter-pager-toggle">
                            <nb-form-field>
                                <input #search class="search" nbInput fullWidth fieldSize="small" type="text" placeholder="Filter..." (keydown.enter)="onSearch(search.value)">
                                <button nbSuffix nbButton ghost (click)="toggleFilter(search.value)">
                                    <nb-icon [icon]="filter ? 'funnel-outline' : 'close-outline'"
                                                pack="eva"
                                                [attr.aria-label]="filter ? 'filter list' : 'reset list'">
                                    </nb-icon>
                                </button>
                            </nb-form-field>
                            <nb-actions size="small">
                                <nb-action icon="book-outline" (click)="hideFilter()" title="Pager">Pager</nb-action>
                            </nb-actions>
                        </div>
                    </ng-container>
                </div>
                <div class="pager" [class.show_pager] = "filter === false">
                    <ubs-pagination *ngIf="!filter" (showFilter)="showFilter($event)"></ubs-pagination>
                    <nb-actions size="small">
                        <nb-action *ngIf="isMulti">
                            <nb-checkbox>Select All</nb-checkbox>
                        </nb-action>
                        <nb-action *ngIf="isMulti">
                            <ubs-ofbiz-multi-submit-btn [enableUpdateSubmit]="submitEnabled" (multiSelectSubmit)="onSubmitMuliSelect($event)"></ubs-ofbiz-multi-submit-btn>
                        </nb-action>
                    </nb-actions>
                </div> 
            </ng-template>
        </div>
    </ng-container>
    <ng-container *ngIf="loaded;else loading">
        <ng-container *ngIf="!isLookup;else noActions">
            <ng-container *ngIf="cardMode;else listMode">
                <div style="background-color:#e4e9f2;padding-top: 1rem;">
                    <ubs-card-list [settings]="settings" [source]="source"></ubs-card-list>
                </div>
            </ng-container>
            <ng-template #listMode>
                <angular2-smart-table #smartTable [settings]="settings" [source]="source" (edit)="editRow($event)" (delete)="deleteRow($event)" (custom)="onCustom($event)" (overview)="onOverview($event)" (editConfirm)="confirmEdit($event)" (deleteConfirm)="confirmDelete($event)" (createConfirm)="confirmCreate($event)"  (userRowSelect)="onUserRowSelect($event)"></angular2-smart-table>
            </ng-template>
        </ng-container>
        <ng-template #noActions>
            <angular2-smart-table #smartTable [settings]="settings" [source]="source" (userRowSelect)="onUserRowSelect($event)"></angular2-smart-table>
        </ng-template>
    </ng-container>
    <ng-template #loading>
        <div class="spinner" [nbSpinner]="true"
          nbSpinnerStatus="danger"
          nbSpinnerSize="large"
          nbSpinnerMessage="Working on it ... ">
    </div>        
    </ng-template>
</ng-container>


